import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CachedDataService, MODULE_CONFIG } from './cached-data.service';

@NgModule({
  imports: [CommonModule],
  providers: [CachedDataService]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only');
    }
  }

  static forRoot(config: any): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: [
        { provide: MODULE_CONFIG, useValue: config }
      ]
    };
  }
}

// Referência de singleton
// https://stackblitz.com/angular/majygqrprxo?file=src%2Fapp%2Fcore%2Fuser.service.ts
